var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags"},_vm._l((_vm.tags),function(tag){return (tag.language_id == _vm.languageId)?_c('span',{staticClass:"single--tag",attrs:{"value":tag.id}},[_vm._v(_vm._s(tag.name))]):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }